/* eslint-disable quote-props */
// axios
import axios from 'axios'

// const baseURL = 'https://mmr-admin.triofi.in/v1'
const baseURL = 'https://courses.makemanyrobots.com/v1'
// const baseURL = 'http://localhost:8000/v1/'

export default axios.create({
  baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
  // You can add your headers here
})
